"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = _interopRequireDefault(require("pricing-pages-unified-ui/constants/ActionTypes"));

var _RequestStatusTypes = _interopRequireDefault(require("pricing-pages-unified-ui/constants/RequestStatusTypes"));

var MarketingContacts = function MarketingContacts() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes.default.MARKETING_CONTACTS_RECEIVED:
      return Object.assign({}, state, {
        onRenewal: payload.marketingContactsOnRenewal
      });

    case _ActionTypes.default.MARKETING_CONTACTS_FAILED:
      return Object.assign({}, state, {
        onRenewal: _RequestStatusTypes.default.FAILED
      });

    case _ActionTypes.default.MC_BETA_ELIGIBILITY_RECEIVED:
      return Object.assign({}, state, {
        isInMCBeta: payload.isInMCBeta
      });

    case _ActionTypes.default.MC_BETA_ELIGIBILITY_FAILED:
      return Object.assign({}, state, {
        isInMCBeta: _RequestStatusTypes.default.FAILED
      });

    default:
      return state;
  }
};

var _default = MarketingContacts;
exports.default = _default;
module.exports = exports.default;